import React, { useEffect, useState, useContext } from 'react';
import HeaderItems from '../Presentation/HeaderItems';
import { isMobileDevice, getTernaryValue } from 'common/utilities/utils';
import { setAnalyticsData } from '../HeaderUtilities/HeaderUtils';
import { withRouter } from 'react-router-dom';
import { UserOrderContext } from 'context/context';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { useDispatch, useSelector } from 'react-redux';
import { Config } from 'common/constants/SharedConstants';
import OrderLookup from 'organisms/FooterComponent/Presentation/orderLookUp';
import { ChannelManager } from 'common/manager';
import { getGoogleTokens } from '@kfc-global/react-shared/redux/Actions/AuthAction';

/**
 * Main Container for Entire Header Components
 * @param - json data from content side
 */

const Header = props => {
  const dispatch = useDispatch();
  const { userOrderStateDispatch } = useContext(UserOrderContext);
  const { contentData = {}, history, tenantReducerData } = props;
  const userParams = useSelector(data => data?.appStateReducer?.userStatus || {});
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  const [openModal, setOpen] = useState(false);
  const { LANGUAGE_SELECTOR } = START_ORDER_CONSTANTS;
  const { allowedLanguages } = useSelector(
    ({ tenantReducer: { basic: { allowedLanguages = [], defaultLanguage } = {}, country: COUNTRY = '' } = {} }) => ({
      allowedLanguages,
      defaultLanguage,
      COUNTRY,
    }),
  );

  /**
   * Method call on window resize
   */

  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileHeader(isMobileView);
  };

  /**
   * Use to add window listner for windown size change
   */
  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);

  /**
   * Method to hold user header item click
   */

  const onHeaderItemSelect = async headerItemSelected => {
    if (headerItemSelected) {
      setAnalyticsData({ headerItemSelected });
    }
    if (isMobile && headerItemSelected !== 'Language Selector') {
      Boolean(document.querySelector('#headermenu-id')) &&
        (document.querySelector('#headermenu-id').style.width = '0px'); //set modal width as zero
      Boolean(document.querySelector('#startorder-container')) &&
        (document.querySelector('#startorder-container').style.display = 'block'); //display startorder container
      document.body.style.overflowY = 'auto'; //enable body scroll
    }
    if (headerItemSelected === 'Menu') {
      history.push({
        pathname: '/menu',
      });
    }

    if (headerItemSelected === 'Account') {
      history.push({
        pathname: '/account',
      });
    }

    if (headerItemSelected === 'Deals') {
      history.push({
        pathname: '/offers',
      });
    }

    if (headerItemSelected.name === START_ORDER_CONSTANTS.ORDER_LOOKUP) {
      setOpen(true);
    }

    if (headerItemSelected === 'Cart') {
      await ChannelManager.BindPhone();
      ChannelManager.googlePhoneToken && dispatch(getGoogleTokens({ token: ChannelManager.googlePhoneToken }));

      if (userParams?.localized) {
        history.push({
          pathname: '/cart',
        });
      } else {
        userOrderStateDispatch({
          type: START_ORDER_CONSTANTS.DISPOSITION_DATA,
          value: { showDisposition: true },
        });
      }
    }

    //open modal if language selector clicked
    headerItemSelected === 'Language Selector' &&
      allowedLanguages.length > 1 &&
      userOrderStateDispatch({ type: LANGUAGE_SELECTOR, value: { showLanguageSelector: true } });
    setTimeout(() => {
      document.getElementById('language_selector') && document.getElementById('language_selector').focus();
    }, 0);
  };

  const onNavigateToHome = () => {
    history.push({
      pathname: '/',
    });
  };

  return (
    <div
      className={`${getTernaryValue(isMobile, 'mobile header', 'desktop header')}`}
      data-testid='HeaderItems-component'
      role='banner'
      data-id={Config.HEADER_ATTR_DATA_ID}
    >
      <HeaderItems
        contentData={contentData}
        isMobile={isMobile}
        clickHandler={onHeaderItemSelect}
        tenantReducerData={tenantReducerData}
        navigateHandler={onNavigateToHome}
        {...props}
        data-testid='header-items'
        dataTestId='headerItems'
      />
      {openModal && (
        <OrderLookup isOpen={true} handleClose={() => setOpen(false)} tenantReducerData={tenantReducerData} />
      )}
    </div>
  );
};

export default withRouter(Header);
